import axios from "@utils/axios";
import { setSession } from "@utils/jwt";
import { UserType } from "../../types/auth";

/**
 * 받은 토큰으로 **세션을 연다.** 로그인 방식이 무엇이든 여기서 만난다.
 *
 * 비밀번호 로그인과 로그인 링크가 각자 세션을 열면, 한쪽만 고쳤을 때 조용히
 * 갈라진다 — 예컨대 권한 목록을 담는 것을 한쪽에서 빠뜨리면 그 경로로 들어온
 * 사람만 버튼이 안 보인다. 들어오는 문은 둘이어도 **여는 방법은 하나**로 둔다.
 */
export const openSession = async (accessToken: string): Promise<UserType> => {
  setSession(accessToken);
  const me = await axios({ method: "get", url: "users/me" });
  return me.data;
};
